import React, { useState, useEffect } from "react";
import { Input, Button, Col, Row, Form } from "antd";
import history from "../../../routes/history";
import { useLocation } from "react-router-dom";
import { Menu, Dropdown } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import "./GigDescription.css";
import { createGig } from "../../../redux/actions";

export default function GigDescription() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [form] = Form.useForm();
  const { TextArea } = Input;

  const [message, setMessage] = useState("");
  const [workauth, setworkauth] = useState("");
  const [workauthError, setworkauthError] = useState(false);

  const title = location.state.gigtitle;
  const facultyname = location.state.facultyn;
  const locationobj = location.state.locobj;
  const skilldetails = location.state.skillDetails;
  const desiredexp = location.state.desiredexp;
  const jobtype = location.state.jobtype;
  const industriesdetails = location.state.industryDetails;

  const dropdownSelect = ({ key }) => {
    setworkauth(key);
    setworkauthError(false);
  };

  const menu = (
    <Menu onClick={dropdownSelect}>
      <Menu.Item key="Citizen">Citizen</Menu.Item>
      <Menu.Item key="Resident/Citizen">Resident</Menu.Item>
      <Menu.Item key="EAD">EAD</Menu.Item>
      <Menu.Item key="H1-B">H1-B</Menu.Item>
    </Menu>
  );

  const submitDetails = async () => {
    if (jobtype === "Permanent") {
      const values = await form.validateFields();
      dispatch(
        createGig({
          Title: title,
          FacilityName: facultyname,
          Location: locationobj,
          Skills: skilldetails,
          Industries: industriesdetails,
          ExperienceLevelName: desiredexp,
          Description: message,
          // workauth,
          JobOrderTypeName: "Permanent",
          JobOrderStatusName: "Draft",
        })
      );
    }

    if (jobtype === "Contract") {
      if (!workauth) {
        setworkauthError(true);
      }
      const values = await form.validateFields();
      dispatch(
        createGig({
          Title: title,
          FacilityName: facultyname,
          Location: locationobj,
          Skills: skilldetails,
          Industries: industriesdetails,
          ExperienceLevelName: desiredexp,
          Description: message,
          workauth,
          JobOrderTypeName: "Contract",
          JobOrderStatusName: "Draft",
        })
      );
    }
  };
  return (
    <>
      <Row style={{ marginTop: "6rem" }}>
        <Col xs={22} sm={22} md={22} lg={14} style={{ margin: "auto" }}>
          <Form form={form}>
            <Row>
              <div className="gigdesc-title">Gig description</div>
              <div className="gigdesc-asterik"> *</div>
            </Row>

            <Col span={24}>
              <Form.Item
                name="message"
                rules={[
                  {
                    required: true,
                    message: "Add a description of the gig",
                  },
                ]}
              >
                <TextArea
                  rows={4}
                  placeholder="Add a description of the ideal candidate  you’re looking to hire and list some job responsibilities..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </Form.Item>
            </Col>

            <Row>
              <div className="gigdesc-title">Work authorization</div>
              <div className="gigdesc-asterik"> *</div>
            </Row>

            {/* <Input className="gigdesc-input" />  */}
            <Dropdown
              overlay={menu}
              className={workauthError ? "gigdesc-DropdownError" : ""}
            >
              <Button
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {workauth} <DownOutlined />
              </Button>
            </Dropdown>
            {workauthError ? (
              <div className="totalerrorMsg">
                Please select work authorization
              </div>
            ) : null}
            <Row style={{ marginTop: "4%" }}>
              <Col span={12}>
                <div className="gigdesc-previousbtn-div">
                  <Button className={"gigdesc-previous-btn"}>Previous</Button>
                </div>
              </Col>
              <Col span={12}>
                <div className="gigdesc-publishbtn-div">
                  <Button
                    className={"gigdesc-publish-btn"}
                    onClick={() => submitDetails()}
                  >
                    Publish gig
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </>
  );
}
